import React from 'react';
import styled from 'styled-components';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  gap: ${(props) => props.gap};
  grid-auto-rows: 150px;
  width: 100%;

  @media (max-width: ${breakpoints.desktop}) {
    grid-auto-rows: 120px;
  }

  @media (max-width: ${breakpoints.tablet}) {
    grid-auto-rows: 70px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 100px;
    gap: 10px;
    display: block;
  }
`;

const GridItem = styled.div`
  grid-column: span ${(props) => props.colSpan || 1};
  grid-row: span ${(props) => props.rowSpan || 1};
  overflow: hidden;
  position: relative;

  @media (max-width: ${breakpoints.mobile}) {
    grid-column: span 2;
    grid-row: span 2;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.4s ease;
`;

export const Gallery = ({ images, columns = 4, gap = '12px' }) => {
  return (
    <Grid columns={columns} gap={gap}>
      {images.map((img) => (
        <GridItem
          key={img.id}
          colSpan={img.colSpan}
          rowSpan={img.rowSpan}
          className={`gallery-item_${img.id}`}
        >
          <Image src={img.src} alt={img.alt || ''} />
        </GridItem>
      ))}
    </Grid>
  );
};
